module.exports = __webpack_public_path__ + "static/media/jNZD.07a9bc32.svg";